import { DownloadSimple } from '@phosphor-icons/react';

export default DownloadSimple;
